module.exports = __webpack_public_path__ + "img/circled-chevron-right_hires.7de6167d.png";